<template>
  <div>
    <section>
      <div class="flex flex-col px-4">
        <h4
          class="font-bold text-grey-darkest"
          v-text="'Edit Projection Period:'"
        />
        <div class="field__label flex items-center justify-between">
          <div class="field__label flex items-center justify-between">
            <label
              class="field__label__text block text-xs mb-2"
              for="interval_start"
              v-text="'Period Start'"
            />
          </div>
        </div>
        <FlatPickr
          id="interval_start"
          v-model="form.interval_start"
          :config="{ minDate: 'today', enableTime: false, dateFormat: 'm/d/Y', defaultDate: form.interval_start }"
          placeholder="Interval Start"
        />
        <div class="field__label flex items-center justify-between">
          <div class="field__label flex items-center justify-between">
            <label
              class="field__label__text block text-xs mb-2"
              for="interval_end"
              v-text="'Period End'"
            />
          </div>
        </div>
        <FlatPickr
          id="interval_end"
          v-model="form.interval_end"
          :config="{ minDate: 'today', enableTime: false, dateFormat: 'm/d/Y', defaultDate: form.interval_end }"
          placeholder="Interval End"
        />
        <button
          type="button"
          :class="{ 'load': loading }"
          :disabled="loading"
          :aria-disabled="loading"
          class="btn mb-4"
          @click="fetchRevenueProjection"
          v-text="'Project Revenue'"
        />
      </div>
    </section>
  </div>
</template>

<script type="text/babel">
import moment from 'moment'
import { mapActions } from 'vuex'
import FlatPickr from 'vue-flatpickr-component'
import Form from 'Base/Resources/assets/js/plugins/Form'

export default {
  name: 'RevenueProjectionForm',
  components: {
    FlatPickr,
  },
  data() {
    return {
      loading: true,
      form: new Form({
        interval_start: moment().format('L'),
        interval_end: moment().add(1, 'years').format('L'),
        breakdown_unit: 'month',
      }),
    }
  },
  mounted() {
    this.fetchRevenueProjection()
  },
  methods: {
    ...mapActions([
      'paymentsGetRevenueProjection',
    ]),
    fetchRevenueProjection() {
      this.$emit('fetchingRevenueProjection')

      this.paymentsGetRevenueProjection(this.form).then(() => {
        this.loading = false

        this.$emit('updateRevenueProjection')
      })
    },
  },
}
</script>
